import { format } from 'date-fns'
import { formatBRCurrency } from '../../../components/storybook'
import { numberFormatText } from 'utils/utils'

const normalizeBenefitType = (value) =>
	(typeof value === 'string' ? value.trim().toUpperCase() : '')

const isCashbackBenefit = (data) => {
	const normalizedType = normalizeBenefitType(data?.typeOfBenefit?.value)
	return normalizedType === 'CASHBACK' || data?.typeOfBenefit?.key === 2
}

export function formatDate(date) {
	if (typeof date === 'string') {
		return format(new Date(date), 'dd/MM/yyyy') ?? '-'
	} else {
		return '-'
	}
}
export function formatDateModal(date) {
	return formatDate(date) ?? '-'
}

export function validateCurrencyMask(data) {
	const pointsMask = data?.simpleRules?.programCurrencySymbol
	const isCashback = isCashbackBenefit(data)
	const benefitConfigType = data?.benefitConfigType?.value

	function replaceDot(value) {
		if (typeof value === 'number') {
			return value.toString().replace('.', ',')
		}
		return value
	}

	if (isCashback && benefitConfigType === 'Percentage') {
		return `${data?.value}%`
	}
	if (isCashback && benefitConfigType === 'Manual') {
		return `${replaceDot(data?.value)}%`
	}

	if (isCashback) {
		return formatBRCurrency(data?.value)
	}

	if (
		data?.typeOfBenefit?.value === 'Points' &&
		data?.benefitConfigType?.value === 'Percentage'
	) {
		return `${data?.value}%`
	}

	if (
		data?.typeOfBenefit?.value === 'Points' &&
		data?.benefitConfigType?.value === 'Fixed'
	) {
		return `${pointsMask} ${data?.value}`
	}
	if (
		data?.typeOfBenefit?.value === 'Points' &&
		data?.benefitConfigType?.value === 'Standard'
	) {
		return `${pointsMask} ${data?.value}`
	} else {
		return '-'
	}
}


export const getEligibleValue = (
	details,
	field
) => {
	const pointsMask = details?.simpleRules?.programCurrencySymbol
	const isCashback = isCashbackBenefit(details)
	if ((details?.benefitConfigType?.value == "Manual" || details?.benefitConfigType?.value == "Percentage") && details?.maximumBenefitGenerationLimit) {
		const base = details?.benefitGeneration?.[field]


		return isCashback
			? formatBRCurrency(base)
			: `${pointsMask} ${base}`

	}

	if (details?.benefitConfigType?.value == "Fixed" && details?.sellQuantity?.totalAllowed) {
		const sell = details?.sellQuantity;


		const qty = Number(sell[field] ?? 0);
		const unit = Number(details?.value ?? 0);
		const base = qty * unit;


		return isCashback
			? formatBRCurrency(base)
			: `${pointsMask} ${base}`

	}


	return "-"
};


export function validateMaskTotal(data) {
	const pointsMask = data?.simpleRules?.programCurrencySymbol

	if (isCashbackBenefit(data)) {
		return formatBRCurrency(data?.sellQuantity?.totalAllowed * data?.value)
	}
	if (data?.typeOfBenefit?.value === 'Points') {
		return `${pointsMask} ${data?.sellQuantity?.totalAllowed * data?.value}`
	}
}
export function validateMaskBalance(data) {
	const pointsMask = data?.simpleRules?.programCurrencySymbol

	if (isCashbackBenefit(data)) {
		return formatBRCurrency(data?.sellQuantity?.remaining * data?.value)
	}
	if (data?.typeOfBenefit?.value === 'Points') {
		return `${pointsMask} ${data?.sellQuantity?.remaining * data?.value}`
	}
}

export const validateMaskMaxValue = (data) => {
	const pointsMask = data?.simpleRules?.programCurrencySymbol

	if (isCashbackBenefit(data)) {
		return formatBRCurrency(data?.maximumBenefitGenerationLimit)
	}
	if (data?.typeOfBenefit?.value === 'Points') {
		return `${pointsMask} ${data?.maximumBenefitGenerationLimit}`
	}
}
